import React from "react";
import { useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext";
import "./ActiveOrderBadge.css";

const ActiveOrderBadge = () => {
  const { activeOrder, isProcessing } = useOrder();
  const navigate = useNavigate();

  if (!activeOrder || !isProcessing) {
    return null;
  }

  const handleClick = () => {
    navigate(`/order-status/${activeOrder.order_id}`);
  };

  const getStatusIcon = () => {
    switch (activeOrder.order_status) {
      case "pending":
        return "⏳";
      case "processing":
        return "🔄";
      case "cooking":
        return "🔥";
      case "ready":
        return "✅";
      default:
        return "⏳";
    }
  };

  const getStatusText = () => {
    switch (activeOrder.order_status) {
      case "pending":
        return "Order Received";
      case "processing":
        return "Preparing";
      case "cooking":
        return "Cooking";
      case "ready":
        return "Ready";
      default:
        return "Processing";
    }
  };

  const statusIcon = getStatusIcon();
  const shouldSpin = statusIcon === "🔄";

  return (
    <div className="active-order-badge" onClick={handleClick}>
      <div className="badge-content">
        <span className={`badge-icon ${shouldSpin ? "spinning" : ""}`}>
          {statusIcon}
        </span>
        <div className="badge-text-container">
          <span className="badge-text">Order #{activeOrder.order_number}</span>
          <span className="badge-status">{getStatusText()}</span>
        </div>
        <span className="badge-arrow">→</span>
      </div>
    </div>
  );
};

export default ActiveOrderBadge;
